const DEFAULT_SPEED = 0.5;
function getOffsetAdd(factor, speed) {
  return `${100 * factor * speed}vh`;
}
function getScrubOffsets(_ref) {
  let {
    speed = DEFAULT_SPEED
  } = _ref;
  const start = getOffsetAdd(-0.5, speed);
  const end = getOffsetAdd(0.5, speed);
  return {
    start,
    end
  };
}
export default function create(options) {
  const {
    speed = DEFAULT_SPEED
  } = options.namedEffect;
  const fromValue = `${-50 * speed}vh`;
  const toValue = `${50 * speed}vh`;
  const easing = 'linear';
  const {
    start,
    end
  } = getScrubOffsets(options.namedEffect);
  return [{
    ...options,
    easing,
    startOffsetAdd: start,
    endOffsetAdd: end,
    keyframes: [{
      translate: `0 ${fromValue}`
    }, {
      translate: `0 ${toValue}`
    }]
  }];
  // only 'continuous' and 0%-100% of range
  /*
   * @keyframes <name> {
   *   from {
   *     translate: 0 <fromValue>;
   *   }
   *   to {
   *     translate: 0 <toValue>;
   *   }
   * }
   */
}
//# sourceMappingURL=ParallaxScroll.js.map